import { Page } from "../oss/Layout/Layout";

export function NotFoundPage() {
  return (
    <Page backHref="~/">
      <div
        style={{
          textAlign: "center",
          paddingInline: "1.5rem",
          paddingBlock: "2rem",
        }}
      >
        There is nothing on this link
      </div>
    </Page>
  );
}
